import * as assert from 'assert';
import { observable } from 'mobx';
import { AbstractStore } from './AbstractStore';

export abstract class AStoreWithMappedData<T extends { id: number }> extends AbstractStore {
    @observable protected recordsMap: Map<number, T> = new Map();

    public allRecords(): Array<T> {
        return Array.from(this.recordsMap.values());
    }

    protected addRecordsToMap(records: Array<T>): void {
        records.forEach((record) => {
            this.recordsMap.set(record.id, record);
        });
    }

    public getRecords(ids: Array<number>): Array<T> {
        console.assert(ids, 'Paramater is undefined');
        const out: Array<T> = [];

        ids.forEach((id) => {
            assert(typeof id === 'number', 'getRecords passed invalid ID: ');
            const record: T | undefined = this.recordsMap.get(id);
            if (record) {
                out.push(record);
            } else {
                assert(false, 'getRecords passed unavailable id');
            }
        });

        return out;
    }

    public getSingleRecord(id: number): T {
        console.assert(id, 'Paramater is undefined');

        const record: T | undefined = this.recordsMap.get(id);

        if (record) {
            return record;
        } else {
            throw new Error('requested unavailable record');
        }
    }

    public hasRecord(id: number): boolean {
        return this.recordsMap.has(id);
    }
}



// WEBPACK FOOTER //
// ./src/_stores/AStoreWithMappedData.ts